<template>
  <div class="leavehospital">
    <el-row>
      <el-form :inline="true" :model="formInline" class="demo-form-inline toolbar" style="padding-bottom:0px;"
        :size="size" @submit.native.prevent>
        <el-form-item :label="leaveHospital.oldmanName" style="margin-left:30px;">
          <el-input v-model.trim="formInline.oldmanName" :placeholder="leaveHospital.enterName" clearable
            @keyup.enter.native.prevent="enterSearchMember"></el-input>
        </el-form-item>
        <el-form-item label="老人身份证" style="margin-left:30px;">
          <el-input v-model.trim="formInline.idCard" placeholder="请输入老人身份证" clearable
            @keyup.enter.native.prevent="enterSearchMember"></el-input>
        </el-form-item>
        <el-form-item>
          <kt-button icon="el-icon-search" :label="leaveHospital.search" type="primary" @click="search" />
        </el-form-item>
        <el-form-item>
          <kt-button icon="el-icon-plus" :label="leaveHospital.add" type="warning" @click="handleAdd" />
        </el-form-item>
      </el-form>
    </el-row>
    <el-row>
      <!--表格内容栏-->
      <el-table style="width: 100%" :data="tableData" :loading="tableLoading" :border="false" :row-style="tableRowStyle"
        :header-cell-style="tableHeaderColor" :cell-style="{ 'text-align': 'center', 'font-size': '16px' }">
        <el-table-column prop="oldmanName" :label="leaveHospital.oldmanName" min-width="100"></el-table-column>
        <el-table-column prop="idCard" :label="leaveHospital.idCard" min-width="150"></el-table-column>
        <el-table-column prop="sex" :label="leaveHospital.sex" min-width="50"></el-table-column>
        <el-table-column prop="birthday" :label="leaveHospital.birthday" min-width="100"></el-table-column>
        <el-table-column prop="leaveDate" :label="leaveHospital.leaveDate" min-width="100"></el-table-column>
        <el-table-column prop="remark" label="出院原因" min-width="100"></el-table-column>
        <el-table-column :label="leaveHospital.operator" min-width="100">
          <template slot-scope="scope">
            <!-- <a @click="handleLook(scope.$index, scope.row)" class="curcor">
              <img class="handedness" src="@/assets/beadhouse/chakan_icon.png" />
            </a> -->
            <el-button style="margin-right: 5px" type="success" size="mini" plain
              @click="handleLook(scope.$index, scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="currentPage" layout="total, prev, pager, next" :total="totalDataNumber" :page-size="pageSize"
        align="center" class="fenye"></el-pagination>
    </el-row>
    <!-- 添加出院的dialog模态框-->
    <el-dialog :title="leaveHospital.addLeaveApply" width="35%" :visible.sync="dialogVisibleAddLeaveApplyForm"
      :close-on-click-modal="false">
      <el-form :model="addLeaveApplyForm" label-width="140px" :rules="addLeaveApplyFormRules" ref="addLeaveApplyForm"
        label-position="right">
        <el-form-item :label="leaveHospital.oldmanName" prop="oldmanName">
          <el-autocomplete v-model.trim="addLeaveApplyForm.oldmanName" auto-complete="off" style="width:80%"
            :fetch-suggestions="querySearchAsync" @select="handleOlderSelect"></el-autocomplete>
        </el-form-item>
        <el-form-item :label="leaveHospital.idCard" v-if="addLeaveApplyForm.oldmanName != ''">
          <el-input v-model="idCard" style="width:80%" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item :label="leaveHospital.inDate" v-if="addLeaveApplyForm.oldmanName != ''">
          <el-input v-model="inDate" style="width:80%" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item :label="leaveHospital.leaveDate" prop="leaveDate">
          <el-date-picker style="width:80%" :editable="false" :clearable="false" v-model="addLeaveApplyForm.leaveDate"
            value-format="yyyy-MM-dd" type="date" @change="changeDate" :placeholder="leaveHospital.selectDate"
            :picker-options="pickerTime"></el-date-picker>
        </el-form-item>
        <el-form-item label="出院类型" prop="type">
          <el-select v-model="addLeaveApplyForm.type" :placeholder="leaveReasonOptions.please" style="width:80%">
            <el-option v-for="item in leaveReasonOptions" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="出院原因">
          <el-input v-model="addLeaveApplyForm.remark" style="width:80%"></el-input>
        </el-form-item>
        <el-form-item :label="leaveHospital.deathReason" prop="deathDesc"
          v-if="addLeaveApplyForm.type == 3 || addLeaveApplyForm.type == 4">
          <el-input type="textarea" :rows="4" v-model="addLeaveApplyForm.deathDesc" style="width:80%"></el-input>
        </el-form-item>
        <el-form-item :label="leaveHospital.deathDate" prop="deathDate"
          v-if="addLeaveApplyForm.type == 3 || addLeaveApplyForm.type == 4">
          <el-date-picker style="width:80%" :editable="false" :clearable="false" v-model="addLeaveApplyForm.deathDate"
            value-format="yyyy-MM-dd" type="date" :placeholder="leaveHospital.selectDate"></el-date-picker>
        </el-form-item>
        <el-form-item label label-width="0px">
          <el-table v-if="paymentList.length > 0" style="width:90%;margin:0 auto;" :data="paymentList" :border="true"
            :header-cell-style="{ 'text-align': 'center', 'font-size': '16px', 'font-weight': '500', 'color': '#666666', 'background-color': 'rgb(238, 231, 231)', }"
            :cell-style="{ 'text-align': 'center', 'font-size': '15px' }">
            <el-table-column prop="itemName" :label="leaveHospital.itemName" min-width="100"></el-table-column>
            <el-table-column :label="leaveHospital.money" min-width="150">
              <template slot-scope="scope">
                <span v-if="scope.row.isFixedPrice == 1">{{ scope.row.expenseItemFee }}</span>
                <el-input v-else v-model.trim="scope.row.expenseItemFee" :placeholder="leaveHospital.please"
                  style="width:90%" @blur="changeExtenseItemFee(scope.$index, scope.row)"></el-input>
              </template>
            </el-table-column>
            <el-table-column :label="leaveHospital.remark" min-width="150">
              <template slot-scope="scope">
                <span v-if="scope.row.isFixedPrice == 1">{{ scope.row.expenseItemRemark }}</span>
                <el-input v-else v-model.trim="scope.row.expenseItemRemark" type="textarea" :rows="2"
                  :placeholder="leaveHospital.please" style="width:90%"
                  @blur="changeExpenseItemRemark(scope.$index, scope.row)"></el-input>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button :size="size" @click.native="dialogVisibleAddLeaveApplyForm = false">取消</el-button>
        <el-button :size="size" type="primary" @click.native="submitFormAddLeaveApplyForm(addLeaveApplyForm)"
          :loading="addLeaveApplyFormLoading">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import KtButton from "@/components/KtButton";
import bus from "@/vuex/eventBus"; //引入eventBus,接收子界面传递的跳转指令,然后在父界面跳转,添加tab
import util from "@/utils/util.js";
export default {
  name: "LeaveHospital",
  components: { KtButton },
  data() {
    return {
      leaveHospital: {
        oldmanName: "老人姓名",
        enterName: "请输入姓名",
        search: "查询",
        add: "添加",
        idCard: "身份证号",
        sex: "性别",
        birthday: "生日",
        leaveDate: "出院时间",
        state: "状态",
        operator: "操作",
        addLeaveApply: "添加出院申请",
        fuzzySearchOldman: "模糊搜索老人",
        selectDate: "选择日期",
        leaveReason: "出院原因",
        please: "请选择",
        deathReason: "死亡原因",
        deathDate: "死亡日期",
        itemName: "类别",
        money: "金额",
        remark: "备注",
        titleInfo: "信息提示",
        reason: "原因",
        title: "你确定不通过出院申请吗?",
        back: "返回",
        dischargeNotice: "出院通知单",
        baseInfo: "基本信息",
        inDate: "入院时间"
      }, //引入 lang 里面的字符串资源
      loading: true,
      size: "medium", //按钮的尺
      formInline: {
        oldmanName: "",
        idCard: ""
      },
      tableData: [], //表格数据
      tableLoading: false, //表格加载的loading
      /* 分页的 */
      currentPage: 1, //初始页
      pageNum: 1, //页码
      pageSize: 10, //每页显示的条数
      totalDataNumber: 0, //数据的总数,
      //添加出院的dialog配置
      dialogVisibleAddLeaveApplyForm: false,
      addLeaveApplyForm: {},
      addLeaveApplyFormRules: {
        oldmanName: [
          { required: true, message: "不能为空", trigger: "change" }
        ],
        leaveDate: [{ required: true, message: "不能为空", trigger: "change" }],
        type: [{ required: true, message: "不能为空", trigger: "change" }],
        deathDesc: [{ required: true, message: "不能为空", trigger: "blur" }],
        deathDate: [{ required: true, message: "不能为空", trigger: "change" }]
      },
      addLeaveApplyFormLoading: false,
      leaveReasonOptions: [], //出院原因
      paymentList: [], //出院费用的数据
      inDate: "",
      outDate: "",
      idCard: "",
      /*  时间小于等于今天 */
      pickerTime: {
        disabledDate: time => {
          console.log(time, "----time---------")
          let nowData = new Date();
          nowData = new Date(nowData.setDate(nowData.getDate()));
          return time > nowData;
        }
      }
    };
  },
  methods: {
    /* 
            修改table tr行的背景色
        */
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #ffffff";
      } else {
        return "background-color: #e4f5f8";
      }
    },

    /* 
            修改table header的背景色
        */
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "color:#2d2d2d;font-weight: 600; text-align: center;font-size: 16px;background-color: #d4f5fa;";
      }
    },
    //查询按钮
    search() {
      if (this.formInline.oldmanName == "") {
        this.queryListWithPage(this.formInline.oldmanName, (this.pageNum = 1));
      } else {
        this.queryListWithPage(
          this.formInline.oldmanName,
          (this.pageNum = 1),
          (this.pageSize = 10)
        );
      }
    },

    //enter键查询
    enterSearchMember(e) {
      console.log("回车搜索", keyCode, e);
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        if (this.formInline.oldmanName == "") {
          this.queryListWithPage(
            this.formInline.oldmanName,
            (this.pageNum = 1)
          );
        } else {
          this.queryListWithPage(
            this.formInline.oldmanName,
            this.pageNum,
            (this.pageSize = 10)
          );
        }
      }
    },

    //出院的日期选择
    changeDate(val) {
      console.log(val, this.inDate);
      this.outDate = val;
    },

    //添加按钮
    handleAdd() {
      this.$nextTick(() => {
        if (this.$refs.addLeaveApplyForm != undefined) {
          this.$refs.addLeaveApplyForm.resetFields();
        }
      });
      this.dialogVisibleAddLeaveApplyForm = true;
      this.addLeaveApplyForm = {
        oldmanName: "",
        oldmanId: "",
        leaveDate: "",
        type: "",
        deathDesc: "",
        deathDate: "",
        outFeeItemDtoList: []
      };
      this.idCard = "";
      this.inDate = "";
      this.queryPaymentList(); //刷新重置数据
    },
    //添加出院申请提交数据
    submitFormAddLeaveApplyForm(addLeaveApplyForm) {
      console.log(addLeaveApplyForm);
      this.$refs.addLeaveApplyForm.validate(valid => {
        if (valid) {
          var outTime = new Date(this.outDate);
          var inTime = new Date(this.inDate);
          var outVal = outTime.getTime();
          var inVal = inTime.getTime();
          let params = new Object();
          params.oldmanId = this.addLeaveApplyForm.oldmanId;
          params.leaveDate = this.addLeaveApplyForm.leaveDate;
          params.remark = this.addLeaveApplyForm.remark;
          params.inDate = this.inDate;
          params.type = this.addLeaveApplyForm.type;
          //非必填字段需要判断是否存在，存在才传
          if (this.addLeaveApplyForm.deathDesc != "") {
            params.deathDesc = this.addLeaveApplyForm.deathDesc;
          }
          if (this.addLeaveApplyForm.deathDate != "") {
            params.deathDate = this.addLeaveApplyForm.deathDate;
          }
          this.addLeaveApplyForm.outFeeItemDtoList = [];
          this.paymentList.forEach(item => {
            let outFeeItemObj = new Object();
            outFeeItemObj.expenseItemId = item.expenseItemId * 1;
            outFeeItemObj.itemName = item.itemName;
            outFeeItemObj.expenseItemFee = String(item.expenseItemFee) * 1;
            outFeeItemObj.expenseItemRemark = item.expenseItemRemark;
            this.addLeaveApplyForm.outFeeItemDtoList.push(outFeeItemObj);
          });
          params.outFeeItemDtoList = this.addLeaveApplyForm.outFeeItemDtoList;
          if (outVal >= inVal) {
            this.addLeaveApplyFormLoading = true;
            this.$postJson("omc/oldOut/addOut", params).then(res => {
              console.log(res, "------");
              if (res.code == 200) {
                this.$message({ message: res.message, type: "success" });
                this.dialogVisibleAddLeaveApplyForm = false;
                this.queryListWithPage();
              } else {
                this.$message({ message: res.message, type: "error" });
              }
              setTimeout(() => {
                this.addLeaveApplyFormLoading = false;
              }, 100);
            });
          } else {
            this.$message({
              message: "出院日期不能早于该老人入院日期",
              type: "error"
            });
          }
        }
      });
    },
    //出院申请 查看详情
    handleLook(index, row) {
      console.log(index, row, "跳转到出院详情页面");
      sessionStorage.setItem("leaveHospitalType", 1); //出院申请是leaveHospitalType=1
      bus.$emit("homePage", {
        type: "jump",
        path: "/LeaveHospitalDetail",
        title: "出院申请详情",
        params: {
          oldOutRow: row
        }
      });
    },

    //模糊查询老人
    querySearchAsync(queryString, cb) {
      //根据 queryString 搜索
      var list = [{}];
      var param = {
        oldmanName: queryString
      };
      console.log(param);
      this.$postJson("omc/oldOut/queryOldmanList", param).then(res => {
        console.log(res);
        if (res.result.oldmanList.length > 0) {
          for (let i of res.result.oldmanList) {
            i.value = i.oldmanName; //将想要展示的数据作为value
          }
          list = res.result.oldmanList;
          cb(list);
        } else {
          let arr = [];
          arr.push({
            uuid: "-1",
            value: ""
          });
          cb(arr);
          setTimeout(() => {
            this.addLeaveApplyForm.oldmanName = "";
          }, 1000);
        }
      });
    },
    //搜索老人选取
    handleOlderSelect(item) {
      this.addLeaveApplyForm.oldmanId = item.oldmanId;
      this.inDate = item.inDate; //入院的时间
      if(item.inDate == null || item.inDate == ""){
        this.inDate = item.registryTime;
      }
      this.idCard = item.idCard; //身份证号
    },

    /* 
      输入赔偿金额
    */
    changeExtenseItemFee(index, row) {
      console.log(index, row);
      console.log(this.paymentList);
      this.paymentList.forEach(item => {
        console.log(item);
        var reg = /(^[0-9](\d+)?(\.\d{1,2})?$)|(^\d\.\d{1,2}$)/g; //大于等于0的数，最多可以有两位小数正则表达式
        //判断是否操作的是同一行
        if (row.expenseItemId == item.expenseItemId) {
          console.log(item.expenseItemFee, "-------");
          if (reg.test(item.expenseItemFee) || item.expenseItemFee == "") {
            if (item.expenseItemFee > 9999999.99) {
              this.$message({
                message: "请输入不大于9999999.99并且最多只能有两位小数的金额",
                type: "error"
              });
              item.expenseItemFee = ""; //清空
            }
          } else {
            this.$message({
              message: "请输入不小于0并且最多只能有两位小数的金额",
              type: "error"
            });
            item.expenseItemFee = ""; //清空
          }
        }
      });
    },

    /* 
      输入备注
    */
    changeExpenseItemRemark(index, row) {
      console.log(index, row);
      console.log(this.paymentList);
      this.paymentList.forEach(item => {
        console.log(item);
        //判断是否操作的是同一行
        if (row.expenseItemId == item.expenseItemId) {
          if (item.expenseItemRemark.length > 30) {
            this.$message({
              message: "请输入不大于30个字符",
              type: "error"
            });
            item.expenseItemRemark = ""; //清空
          }
        }
      });
    },

    /* 
      查询出院的费用 
    */
    queryPaymentList() {
      this.paymentList = []; //清空数据，防止累加
      this.$postJson("omc/oldOut/queryOldmanList").then(res => {
        if (res.code == 200) {
          if (res.result.paymentList.length > 0) {
            res.result.paymentList.forEach(item => {
              console.log(item.expenseItemList, "-----");
              if (item.expenseItemList.length > 0) {
                item.expenseItemList.forEach(temp => {
                  console.log(temp, "====");
                  var paymentObj = new Object();
                  paymentObj.isFixedPrice = temp.isFixedPrice; //是否是不固定和固定收费  0-----不固定   1-----固定
                  paymentObj.expenseItemId = temp.expenseItemId; //出院收费项目的id
                  paymentObj.itemName = temp.itemName; //出院收费项目的名称
                  paymentObj.expenseItemFee =
                    temp.chargeStandard != null ? temp.chargeStandard : ""; //出院收费的费用
                  paymentObj.expenseItemRemark =
                    temp.remark != null ? temp.remark : ""; //出院收费项备注
                  this.paymentList.push(paymentObj);
                });
              }
            });
          }
        } else {
          this.$message({ type: 'error', message: res.message })
        }
      });
    },

    /* 
      查询老人出院列表
    */
    queryListWithPage() {
      let params = {};
      if (this.formInline.oldmanName != "" || null || undefined) {
        params.oldmanName = this.formInline.oldmanName;
      }
      if (this.formInline.idCard != "" || null || undefined) {
        params.idCard = this.formInline.idCard;
      }
      params.pageNum = this.pageNum;
      params.pageSize = this.pageSize;
      this.tableData = []; //请求之前先清空数据
      this.tableLoading = true;
      console.log(params);
      this.$postJson("omc/oldOut/queryListWithPage", params).then(res => {
        console.log(res, "----");
        if (res.code == 200) {
          if (res.result.list != null) {
            this.pageSize = res.result.pageSize;
            this.currentPage = res.result.pageNum;
            this.totalDataNumber = res.result.total * 1;
            //循环遍历处理数据
            res.result.list.forEach(item => {
              var object = {};
              object = Object.assign({}, item);
              object.sex = util.getSexFromIdCard(item.idCard) ==0?"男":"女";
              switch (item.state) {
                case 1:
                  object.state = "未提交";
                  break;
                case 2:
                  object.state = "申请中";
                  break;
                case 3:
                  object.state = "接待室审核通过";
                  break;
                case 4:
                  object.state = "审核未通过";
                  break;
                case 5:
                  object.state = "收费室确认";
                  break;
                case 6:
                  object.state = "服务部确认";
                  break;
                default:
                  object.state = "医疗部审核通过";
              }
              this.tableData.push(object);
            });
          } else {
            this.tableData = [];
            this.pageSize = 10;
            this.currentPage = 1;
            this.totalDataNumber = 0;
          }
        } else {
          this.tableData = [];
          this.pageSize = 10;
          this.currentPage = 1;
          this.totalDataNumber = 0;
        }
        setTimeout(() => {
          this.tableLoading = false;
        }, 1000);
      });
    },

    /* 
      初始页currentPage、初始每页数据数pagesize和数据data
    */
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      //改变每页显示的条数
      this.PageSize = val;
      this.queryListWithPage();
    },

    /* 
      当前页变化
    */
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNum = val;
      this.queryListWithPage();
    },
    //初始化出院原因
    initialLeaveReasonOptions() {
      var leaveReason = ["试住不适应", "正常出院", "院内死亡", "院外死亡"];
      for (var i = 0; i < leaveReason.length; i++) {
        var item = {};
        item.value = i + 1;
        item.label = leaveReason[i];
        this.leaveReasonOptions.push(item);
      }
    }
  },
  created() {
    this.initialLeaveReasonOptions();
    this.queryPaymentList();
  },
  mounted() {
    this.queryListWithPage();
  }
};
</script>
<style lang="scss" scoped>
.leavehospital {
  width: 100%;
  height: 100%;
  background: #fefefe;
}

// ::v-deep深度作用选择符
::v-deep .el-dialog__header {
  text-align: center;
  background: rgb(238, 231, 231);
  border-bottom: 2px solid rgb(211, 207, 207);
}

::v-deep .el-dialog__header {
  height: 19px !important;
  text-align: left;
}

::v-deep .el-dialog__footer {
  text-align: center;
}
</style>

